module.exports = __webpack_public_path__ + "static/rooms3-1bf04ba2391889ba0a5bb1b5f5af5bdf.jpg";